// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2KcXQ","title":"Header_title__1jNLy","left":"Header_left__ERhuI","clinicName":"Header_clinicName__2uwbj"};